import '../../App.css';
import '../../Css/Description.css';
import '../../Css/Team.css'
import data from '../../JsonFiles/Equipe.json';
import TeamTile from './TeamTile';

export default function PersonnelDescription() {

  return (
            <div className='team-tiles-container'>
               
                {data.equipe.map((item, i) => (
                    <TeamTile key={i} name={item.name} title={item.title} description={item.description} image={item.image}></TeamTile>
                    ))}
            </div>
    );
  }